import {VIEW_TEAM_LOADING, VIEW_TEAM_SUCCESS, VIEW_TEAM_ERROR} from "../../../constant/actionTypes";

const viewTeamReducer = (state = {}, action) => {
    switch (action.type) {
        case VIEW_TEAM_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case VIEW_TEAM_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response,
            };
            return obj;
        }
        case VIEW_TEAM_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default viewTeamReducer;